import { Err, ResponseData } from 'types';

import { http } from '.';

const buildQueryParams = (params) => {
  const queryParams = new URLSearchParams();
  Object.keys(params).forEach((key) => {
    if (Array.isArray(params[key])) {
      if (params[key].length > 0) {
        params[key].forEach((value) => queryParams.append(key, value));
      }
    } else if (params[key] !== undefined && params[key] !== '') {
      queryParams.append(key, params[key]);
    }
  });
  return queryParams.toString();
};

export const downloadInvoiceZipByQueueId = async (
  invoiceZipQueueId: string
) => {
  return await http.get<Err, Blob>(`/IO/DownloadInvoiceZipByQueueId/IO`, {
    params: {
      invoiceZipQueueId,
    },
    responseType: 'blob',
  });
};

export const getInvoiceReportDownload = async (invoiceZipQueueId: string) => {
  return await http.get(`IO/DownloadInvoiceZipByQueueId/IO`, {
    params: { invoiceZipQueueId },
    responseType: 'blob',
  });
};
export const getReportInvoice = async (
  FromDate: string,
  ToDate: string,
  IsInvoice: boolean = true,
  Partner: number[],
  FileType: string = 'Zip'
) => {
  const queryParams = buildQueryParams({
    startDate: FromDate,
    endDate: ToDate,
    isInvoice: IsInvoice,
    partnerList: Partner,
    fileType: FileType,
  });

  return await http.get<Err, ResponseData<any>>(
    `/IO/ZipPdfFiles?${queryParams}`
  );
};

export const getReportIncomesAndExpensesExcell = async (
  FromDate: string,
  ToDate: string,
  Status: number[],
  FileType: string = 'Excel'
) => {
  const queryParams = buildQueryParams({
    FromDate: FromDate,
    ToDate: ToDate,
    Status: Status,
    FileType: FileType,
  });

  return await http.get<Err, ResponseData<any>>(
    `ReportFiles/GetIncomeAndExpensesDetails?${queryParams}`
  );
};
export const getReportIncomesAndExpensesPdf = async (
  FromDate: string,
  ToDate: string,
  Status: number[],
  FileType: string = 'Pdf'
) => {
  const queryParams = buildQueryParams({
    FromDate: FromDate,
    ToDate: ToDate,
    Status: Status,
    FileType: FileType,
  });

  return await http.get<Err, ResponseData<any>>(
    `ReportFiles/GetIncomeAndExpensesDetails?${queryParams}`
  );
};
export const getReportIncomesAndExpenses = async (
  FromDate: string,
  ToDate: string,
  Status: number[] | 'all',
  IsInvoice: boolean,
  pageSize: number,
  pageIndex: number
) => {
  const statusParam = Status === 'all' ? '' : Status;
  return await http.get<Err, ResponseData<any>>(
    `/Report/GetIncomeAndExpensesDetails?FromDate=${FromDate}&ToDate=${ToDate}&Status=${statusParam}&IsInvoice=${IsInvoice}&PageIndex=${pageIndex}&PageSize=${pageSize}`
  );
};

export const getReportJobNumberExcell = async (
  FromDate: string,
  ToDate: string,
  StatusId: any,
  Jobnumbers: any,
  FileType: string = 'Excel'
) => {
  const queryParams = buildQueryParams({
    FromDate: FromDate,
    ToDate: ToDate,
    StatusId: StatusId,
    Jobnumbers: Jobnumbers,
    FileType: FileType,
  });

  return await http.get<Err, ResponseData<any>>(
    `ReportFiles/GetByJobNumberDetails?${queryParams}`
  );
};

export const getReportJobNumberPdf = async (
  FromDate: string,
  ToDate: string,
  StatusId: any,
  Jobnumbers: any,
  FileType: string = 'Pdf'
) => {
  const queryParams = buildQueryParams({
    FromDate: FromDate,
    ToDate: ToDate,
    StatusId: StatusId,
    Jobnumbers: Jobnumbers,
    FileType: FileType,
  });

  return await http.get<Err, ResponseData<any>>(
    `ReportFiles/GetByJobNumberDetails?${queryParams}`
  );
};

export const getReportJobNumber = async (
  FromDate,
  ToDate,
  IsInvoice,
  StatusId,
  Jobnumbers,
  pageSize,
  pageIndex
) => {
  const queryParams = buildQueryParams({
    FromDate,
    ToDate,
    IsInvoice,
    StatusId,
    Jobnumbers,
    pageSize,
    pageIndex,
  });
  return await http.get(`/Report/GetByJobNumberDetails?${queryParams}`);
};

export const getReportJobNumberSummary = async (StatusId, Jobnumbers) => {
  const queryParams = buildQueryParams({ StatusId, Jobnumbers });
  return await http.get(`/Report/GetByJobNumberSummary?${queryParams}`);
};
export const getReportIncomesAndExpensesSummary = async (
  FromDate: string,
  ToDate: string,
  Status: number[]
) => {
  return await http.get<Err, ResponseData<any>>(
    `/Report/GetIncomeAndExpensesSummary?FromDate=${FromDate}&ToDate=${ToDate}&Status=${Status}`
  );
};
export const getReportCashFlowExcell = async (
  FromDate: string,
  ToDate: string,
  PaymentMethod: number,
  FileType: string = 'Excel'
) => {
  const queryParams = buildQueryParams({
    FromDate: FromDate,
    ToDate: ToDate,
    PaymentMethod: PaymentMethod,

    FileType: FileType,
  });

  return await http.get<Err, ResponseData<any>>(
    `ReportFiles/GetCashFlowDetails?${queryParams}`
  );
};
export const getReportCashFlowPdf = async (
  FromDate: string,
  ToDate: string,

  PaymentMethod: number,
  FileType: string = 'Pdf'
) => {
  const queryParams = buildQueryParams({
    FromDate: FromDate,
    ToDate: ToDate,
    PaymentMethod: PaymentMethod,

    FileType: FileType,
  });

  return await http.get<Err, ResponseData<any>>(
    `ReportFiles/GetCashFlowDetails?${queryParams}`
  );
};

export const getReportCashFlow = async (
  FromDate,
  ToDate,
  IsInvoice,
  PaymentMethod,
  pageSize,
  pageIndex
) => {
  const queryParams = buildQueryParams({
    FromDate,
    ToDate,
    IsInvoice,
    PaymentMethod,
    pageSize,
    pageIndex,
  });
  return await http.get(`/Report/GetCashFlowDetails?${queryParams}`);
};
export const getReportCashFlowSummary = async (
  FromDate,
  ToDate,
  PaymentMethod
) => {
  const queryParams = buildQueryParams({
    FromDate,
    ToDate,
    PaymentMethod,
  });
  return await http.get(`/Report/GetCashFlowSummary?${queryParams}`);
};

export const getReportManagerExcell = async (
  FromDate: string,
  ToDate: string,
  Status: number[],
  manager: number,
  FileType: string = 'Excel'
) => {
  const queryParams = buildQueryParams({
    FromDate: FromDate,
    ToDate: ToDate,
    Status: Status,
    manager: manager,
    FileType: FileType,
  });

  return await http.get<Err, ResponseData<any>>(
    `ReportFiles/GetByManagerDetails?${queryParams}`
  );
};
export const getReportManagerPdf = async (
  FromDate: string,
  ToDate: string,
  Status: number[],
  manager: number,
  FileType: string = 'Pdf'
) => {
  const queryParams = buildQueryParams({
    FromDate: FromDate,
    ToDate: ToDate,
    Status: Status,
    manager: manager,
    FileType: FileType,
  });

  return await http.get<Err, ResponseData<any>>(
    `ReportFiles/GetByManagerDetails?${queryParams}`
  );
};

export const getReportManager = async (
  FromDate: string,
  ToDate: string,
  IsInvoice: boolean,
  Status: number[],
  manager: number,
  pageSize: number,
  pageIndex: number
) => {
  return await http.get<Err, ResponseData<any>>(
    `/Report/GetByManagerDetails?FromDate=${FromDate}&ToDate=${ToDate}&Status=${Status}&Manager=${manager}&IsInvoice=${IsInvoice}&PageIndex=${pageIndex}&PageSize=${pageSize}`
  );
};

export const getReportManagerSummary = async (
  FromDate: string,
  ToDate: string,
  Status: number[],
  Manager: number
) => {
  return await http.get<Err, ResponseData<any>>(
    `/Report/GetByManagerSummary?FromDate=${FromDate}&ToDate=${ToDate}&Status=${Status}&Manager=${Manager}`
  );
};
export const getReportDebitorExcell = async (
  PartnerId: number,
  FileType: string = 'Excel'
) => {
  const queryParams = buildQueryParams({
    PartnerId: PartnerId,
    FileType: FileType,
  });

  return await http.get<Err, ResponseData<any>>(
    `ReportFiles/GetInvoicesByDebitor?${queryParams}`
  );
};
export const getReportCreditorExcell = async (
  PartnerId: number,
  FileType: string = 'Excel'
) => {
  const queryParams = buildQueryParams({
    PartnerId: PartnerId,
    FileType: FileType,
  });

  return await http.get<Err, ResponseData<any>>(
    `ReportFiles/GetCostsByCreditor?${queryParams}`
  );
};
export const getReportPartnerExcell = async (
  FromDate: string,
  ToDate: string,
  partner: number,
  FileType: string = 'Excel'
) => {
  const queryParams = buildQueryParams({
    FromDate: FromDate,
    ToDate: ToDate,
    partner: partner,
    FileType: FileType,
  });

  return await http.get<Err, ResponseData<any>>(
    `ReportFiles/GetCustomerBalanceInfo?${queryParams}`
  );
};

export const getCustomerBalanceInfoCreditorPdf = async (
  ToDate: string,
  partner: number,
  FileType: string = 'Pdf'
) => {
  const queryParams = buildQueryParams({
    ToDate: ToDate,
    Partner: partner,
    FileType: FileType,
  });

  return await http.get<Err, ResponseData<any>>(
    `ReportFiles/GetCreditorBalanceInfo?${queryParams}`
  );
};

export const getCustomerBalanceInfoDebitorPdf = async (
  ToDate: string,
  partner: number,
  FileType: string = 'Pdf'
) => {
  const queryParams = buildQueryParams({
    ToDate: ToDate,
    Partner: partner,
    FileType: FileType,
  });

  return await http.get<Err, ResponseData<any>>(
    `ReportFiles/GetDebitorBalanceInfo?${queryParams}`
  );
};

export const getReportDebitorPdf = async (
  PartnerId: number,
  FileType: string = 'Pdf'
) => {
  const queryParams = buildQueryParams({
    PartnerId: PartnerId,
    FileType: FileType,
  });

  return await http.get<Err, ResponseData<any>>(
    `ReportFiles/GetInvoicesByDebitor?${queryParams}`
  );
};

export const getReportCreditorPdf = async (
  PartnerId: number,
  FileType: string = 'Pdf'
) => {
  const queryParams = buildQueryParams({
    PartnerId: PartnerId,
    FileType: FileType,
  });

  return await http.get<Err, ResponseData<any>>(
    `ReportFiles/GetCostsByCreditor?${queryParams}`
  );
};

export const getReportPartnerPdf = async (
  FromDate: string,
  ToDate: string,
  partner: number,
  FileType: string = 'Pdf'
) => {
  const queryParams = buildQueryParams({
    FromDate: FromDate,
    ToDate: ToDate,
    partner: partner,
    FileType: FileType,
  });

  return await http.get<Err, ResponseData<any>>(
    `ReportFiles/GetCustomerBalanceInfo?${queryParams}`
  );
};

export const getReportDebitorCustomerBalance = async (
  ToDate: string,
  partner: number,
  pageSize: number,
  pageIndex: number
) => {
  return await http.get<Err, ResponseData<any>>(
    `/Report/GetDebitorBalanceInfo?ToDate=${ToDate}&Partner=${partner}&PageIndex=${pageIndex}&PageSize=${pageSize}`
  );
};

export const getReportCreditorCustomerBalance = async (
  ToDate: string,
  partner: number,
  pageSize: number,
  pageIndex: number
) => {
  return await http.get<Err, ResponseData<any>>(
    `/Report/GetCreditorBalanceInfo?ToDate=${ToDate}&Partner=${partner}&PageIndex=${pageIndex}&PageSize=${pageSize}`
  );
};

export const getReportPartner = async (
  FromDate: string,
  ToDate: string,
  IsInvoice: boolean,
  partner: number,
  pageSize: number,
  pageIndex: number
) => {
  return await http.get<Err, ResponseData<any>>(
    `/Report/GetCustomerBalanceInfo?FromDate=${FromDate}&ToDate=${ToDate}&Partner=${partner}&IsInvoice=${IsInvoice}&PageIndex=${pageIndex}&PageSize=${pageSize}`
  );
};
export const getReportCreditorBalance = async (
  partner: number,
  pageSize: number,
  pageIndex: number
) => {
  return await http.get<Err, ResponseData<any>>(
    `/Report/GetCostsByCreditor?partnerId=${partner}&PageIndex=${pageIndex}&PageSize=${pageSize}`
  );
};
export const getReportCreditorBalanceSummary = async (partner: number) => {
  return await http.get<Err, ResponseData<any>>(
    `/Report/GetCostsSummaryByCreditor?partnerId=${partner}`
  );
};
export const getReportDebitorBalance = async (
  partner: number,
  pageSize: number,
  pageIndex: number
) => {
  return await http.get<Err, ResponseData<any>>(
    `/Report/GetInvoicesByDebitor?partnerId=${partner}&PageIndex=${pageIndex}&PageSize=${pageSize}`
  );
};
export const getReportDebitorBalanceSummary = async (partner: number) => {
  return await http.get<Err, ResponseData<any>>(
    `/Report/GetInvoicesSummaryByDebitor?partnerId=${partner}`
  );
};
export const getReportPartnerSummary = async (
  FromDate: string,
  ToDate: string,
  partner: number
) => {
  return await http.get<Err, ResponseData<any>>(
    `/Report/GetCustomerBalanceInfoSummary?FromDate=${FromDate}&ToDate=${ToDate}&Partner=${partner}`
  );
};

export const getReportCreditorCustomerBalanceSummary = async (
  ToDate: string,
  partner: number
) => {
  return await http.get<Err, ResponseData<any>>(
    `/Report/GetCreditorBalanceInfoSummary?ToDate=${ToDate}&Partner=${partner}`
  );
};

export const getReportDebitorCustomerBalanceSummary = async (
  ToDate: string,
  partner: number
) => {
  return await http.get<Err, ResponseData<any>>(
    `/Report/GetDebitorBalanceInfoSummary?ToDate=${ToDate}&Partner=${partner}`
  );
};

export const getReportTaxTypesExcell = async (
  FromDate: string,
  ToDate: string,
  StatusId: any,
  TaxType: any,
  Partner: any,
  FileType: string = 'Excel'
) => {
  const queryParams = buildQueryParams({
    FromDate: FromDate,
    ToDate: ToDate,
    StatusId: StatusId,
    TaxType: TaxType,
    Partner: Partner,
    FileType: FileType,
  });

  return await http.get<Err, ResponseData<any>>(
    `ReportFiles/GetByTaxTypeDetails?${queryParams}`
  );
};

export const getReportTaxTypesPdf = async (
  FromDate: string,
  ToDate: string,
  StatusId: any,
  TaxType: any,
  Partner: any,
  FileType: string = 'Pdf'
) => {
  const queryParams = buildQueryParams({
    FromDate: FromDate,
    ToDate: ToDate,
    StatusId: StatusId,
    TaxType: TaxType,
    Partner: Partner,
    FileType: FileType,
  });

  return await http.get<Err, ResponseData<any>>(
    `ReportFiles/GetByTaxTypeDetails?${queryParams}`
  );
};

export const getReportTaxTypes = async (
  FromDate,
  ToDate,
  IsInvoice,
  StatusId,
  TaxType,
  Partner,
  pageSize,
  pageIndex
) => {
  const queryParams = buildQueryParams({
    FromDate,
    ToDate,
    IsInvoice,
    StatusId,
    TaxType,
    Partner,
    pageSize,
    pageIndex,
  });
  return await http.get(`/Report/GetByTaxTypeDetails?${queryParams}`);
};

export const getReportTaxTypesSummary = async (
  FromDate,
  ToDate,
  StatusId,
  TaxType,
  Partner
) => {
  const queryParams = buildQueryParams({
    FromDate,
    ToDate,
    StatusId,
    TaxType,
    Partner,
  });
  return await http.get(`/Report/GetByTaxTypeSummary?${queryParams}`);
};
export const getReportSaleTypes = async (
  FromDate,
  ToDate,
  IsInvoice,
  StatusId,
  SaleType,
  Partner,
  pageSize,
  pageIndex
) => {
  const queryParams = buildQueryParams({
    FromDate,
    ToDate,
    IsInvoice,
    StatusId,
    SaleType,
    Partner,
    pageSize,
    pageIndex,
  });
  return await http.get(`/Report/GetBySaleTypeDetails?${queryParams}`);
};

export const getReportSaleTypesSummary = async (
  FromDate,
  ToDate,
  StatusId,
  SaleType,
  Partner
) => {
  const queryParams = buildQueryParams({
    FromDate,
    ToDate,
    StatusId,
    SaleType,
    Partner,
  });
  return await http.get(`/Report/GetBySaleTypeSummary?${queryParams}`);
};
export const getReportSaleTypesExcell = async (
  FromDate: string,
  ToDate: string,
  StatusId: any,
  TaxType: any,
  Partner: any,
  FileType: string = 'Excel'
) => {
  const queryParams = buildQueryParams({
    FromDate: FromDate,
    ToDate: ToDate,
    StatusId: StatusId,
    TaxType: TaxType,
    Partner: Partner,
    FileType: FileType,
  });

  return await http.get<Err, ResponseData<any>>(
    `ReportFiles/GetBySaleTypeDetails?${queryParams}`
  );
};
export const getReportSaleTypesPdf = async (
  FromDate: string,
  ToDate: string,
  StatusId: any,
  TaxType: any,
  Partner: any,
  FileType: string = 'Pdf'
) => {
  const queryParams = buildQueryParams({
    FromDate: FromDate,
    ToDate: ToDate,
    StatusId: StatusId,
    TaxType: TaxType,
    Partner: Partner,
    FileType: FileType,
  });

  return await http.get<Err, ResponseData<any>>(
    `ReportFiles/GetBySaleTypeDetails?${queryParams}`
  );
};
export const getReportBank = async (
  FromDate,
  ToDate,
  IsInvoice,
  BankData,
  pageSize,
  pageIndex
) => {
  const queryParams = buildQueryParams({
    FromDate,
    ToDate,
    IsInvoice,
    BankData,
    pageSize,
    pageIndex,
  });
  return await http.get(`/Report/GetByBankDetails?${queryParams}`);
};

export const getReportBankSummary = async (FromDate, ToDate, BankData) => {
  const queryParams = buildQueryParams({ FromDate, ToDate, BankData });
  return await http.get(`/Report/GetByBankSummary?${queryParams}`);
};
export const getReportBankExcell = async (
  FromDate: string,
  ToDate: string,
  BankData: any,
  FileType: string = 'Excel'
) => {
  const queryParams = buildQueryParams({
    FromDate: FromDate,
    ToDate: ToDate,
    BankData: BankData,
    FileType: FileType,
  });

  return await http.get<Err, ResponseData<any>>(
    `ReportFiles/GetByBankDetails?${queryParams}`
  );
};

export const getReportBankPdf = async (
  FromDate: string,
  ToDate: string,
  BankData: any,
  FileType: string = 'Pdf'
) => {
  const queryParams = buildQueryParams({
    FromDate: FromDate,
    ToDate: ToDate,
    BankData: BankData,
    FileType: FileType,
  });

  return await http.get<Err, ResponseData<any>>(
    `ReportFiles/GetByBankDetails?${queryParams}`
  );
};

export const getReportCancelled = async (
  FromDate,
  ToDate,
  IsInvoice,
  SaleType,
  Partner,
  pageSize,
  pageIndex
) => {
  const queryParams = buildQueryParams({
    FromDate,
    ToDate,
    IsInvoice,
    SaleType,
    Partner,
    pageSize,
    pageIndex,
  });
  return await http.get(`/Report/GetCancelledInvoiceDetails?${queryParams}`);
};

export const getReportCanceledExcell = async (
  FromDate: string,
  ToDate: string,
  SaleType: any,
  Partner: any,
  FileType: string = 'Excel'
) => {
  const queryParams = buildQueryParams({
    FromDate: FromDate,
    ToDate: ToDate,
    SaleType: SaleType,
    Partner: Partner,
    FileType: FileType,
  });

  return await http.get<Err, ResponseData<any>>(
    `ReportFiles/GetCancelledInvoiceDetails?${queryParams}`
  );
};
export const getReportCanceledPdf = async (
  FromDate: string,
  ToDate: string,
  SaleType: any,
  Partner: any,
  FileType: string = 'Pdf'
) => {
  const queryParams = buildQueryParams({
    FromDate: FromDate,
    ToDate: ToDate,
    SaleType: SaleType,
    Partner: Partner,
    FileType: FileType,
  });

  return await http.get<Err, ResponseData<any>>(
    `ReportFiles/GetCancelledInvoiceDetails?${queryParams}`
  );
};

export const getReportMeasurementsExcell = async (
  FromDate: string,
  ToDate: string,
  TaxType: any,
  Partner: any,
  FileType: string = 'Excel'
) => {
  const queryParams = buildQueryParams({
    FromDate: FromDate,
    ToDate: ToDate,
    TaxType: TaxType,
    Partner: Partner,
    FileType: FileType,
  });

  return await http.get<Err, ResponseData<any>>(
    `ReportFiles/GetByMeasurementDetailed?${queryParams}`
  );
};
export const getReportMeasurementsPdf = async (
  FromDate: string,
  ToDate: string,
  TaxType: any,
  Partner: any,
  FileType: string = 'Pdf'
) => {
  const queryParams = buildQueryParams({
    FromDate: FromDate,
    ToDate: ToDate,
    TaxType: TaxType,
    Partner: Partner,
    FileType: FileType,
  });

  return await http.get<Err, ResponseData<any>>(
    `ReportFiles/GetByMeasurementDetailed?${queryParams}`
  );
};

export const getReportMeasurements = async (
  FromDate,
  ToDate,
  IsInvoice,
  Measurement,
  Partner,
  pageSize,
  pageIndex
) => {
  const queryParams = buildQueryParams({
    FromDate,
    ToDate,
    IsInvoice,
    Measurement,
    Partner,
    pageSize,
    pageIndex,
  });
  return await http.get(`/Report/GetByMeasurementDetailed?${queryParams}`);
};

export const getReportMeasurementsSummary = async (
  FromDate,
  ToDate,
  Measurement,
  Partner
) => {
  const queryParams = buildQueryParams({
    FromDate,
    ToDate,
    Measurement,
    Partner,
  });
  return await http.get(`/Report/GetByMeasurementSummary?${queryParams}`);
};
